<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-06 17:53:20
 * @Description: 选择找回密码方式
-->
<template>
	<div class="way_back">
		<NavBar
			:title="$t(`webapp.menus.${$route.meta.field}`)"
			:left-arrow="$route.meta.isShowArrow"
			@click-left="$router.back()"
			nav-bar-icon-color="#000"
			class="navbarSelf"
		></NavBar>

		<div class="common_list_self">
			<div class="c_l_s_item" v-for="item in list" :key="item.value" @click="handleJump(item.value)">
				<div class="c_l_s_left">
					<img class="c_l_s_l_img" :src="item.src" />
					<span>{{ item.name }}</span>
				</div>
				<Icon class="c_l_s_right" name="arrow" />
			</div>
		</div>
	</div>
</template>

<script>
import { NavBar, Icon } from "vant";
import { commonAPI } from "@/apis";
import { toast } from "@/utils/toast";

import i_phone from "@/assets/mAssets/images/forget/phone.png";
import i_email from "@/assets/mAssets/images/forget/email.png";
import i_question from "@/assets/mAssets/images/forget/question.png";

export default {
	name: "WayBack",
	components: { NavBar, Icon },
	data() {
		return {
			safeSetInfo: {},
			defaultList: [
				{ value: "3", name: this.$t("webapp.forget.type_mobile"), src: i_phone },
				{ value: "2", name: this.$t("webapp.forget.type_email"), src: i_email },
				{ value: "1", name: this.$t("webapp.forget.type_question"), src: i_question },
			],
			list: [],
		};
	},
	created() {
		this.getSafeSet();
	},
	methods: {
		// 获取安全配置
		async getSafeSet() {
			const { code, data, message } = await commonAPI.getAction("setting/safe/get");
			if (code == 0) {
				this.safeSetInfo = { ...data };
				this.defaultList.forEach((el) => {
					let flag = data.zhmmfs.includes(el.value);
					if (flag) {
						this.list.push(el);
					}
				});
			} else {
				toast(message);
			}
		},
		// 跳转
		handleJump(value) {
			this.$router.push({
				path: "/mforget/verifyInfo",
				query: { id: value, safeSetInfo: JSON.stringify(this.basicSetInfo) },
			});
		},
	},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/base.scss";
</style>
